export default __webpack_public_path__ + "static/media/cab_red_acre01-1.0a290dde.PNG";